/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { css } from '@emotion/react'

export const editPageSectionStyle = {
  padding: '0',
  width: '100%',

  '@media (max-width: 1200px)': {
    margin: '0 auto',
  },
}

export const noDataFlexGroupStyle = css({
  gap: '24px',
})

export const noDataLeftPanelStyle = css({
  maxWidth: '392px',
})

export const noDataRightPanelStyle = css({
  maxWidth: '784px',
})

export const noDataPromptStyle = css({
  margin: 0,
  maxWidth: '552px',
})
